"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import { pushGtmEvent, setGtmEnabled } from "@package/util/utils/gtm";
import { GTM_EVENTS } from "@package/util/utils/gtmEvents";
import { useGtm } from "@package/util/context/GtmContext";

export default function GtmTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const prevPathRef = useRef("");
  const companyDetailsTrackedRef = useRef(false);
  const { gtmEnabled, companyDetails } = useGtm();

  // Sync GTM enabled state to the utility function
  useEffect(() => {
    setGtmEnabled(gtmEnabled);
  }, [gtmEnabled]);

  // Track page views
  useEffect(() => {
    if (pathname !== prevPathRef.current) {
      prevPathRef.current = pathname;
      pushGtmEvent(GTM_EVENTS.pageView);
    }
  }, [pathname, searchParams]);

  return null;
}
